<mat-dialog-actions class="shipping-dialog-header">
    <div class="shipping-header-content">
        <span class="shipping-eyebrow">
            PEDIDO
        </span>
        <h2 class="shipping-title">
            ¿Cómo quieres recibir tu pedido?
        </h2>
        <p class="shipping-subtitle">
            Selecciona la opción que prefieras para continuar.
        </p>
    </div>
    <button class="shipping-dialog-close" mat-dialog-close type="button" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="shipping-dialog-content">
    <!-- =====================================================
         TIPO DE ENVÍO
         ===================================================== -->
    <section class="shipping-type-section">
        <button type="button" class="shipping-type-option" [class.selected]="!shippeable"
            (click)="changeSelectedShipping('Pick')">
            <div class="shipping-type-icon">
                <mat-icon>storefront</mat-icon>
            </div>
            <div class="shipping-type-text">
                <strong>Recoger en sucursal</strong>
                <span>Recoge tu pedido directamente en Nina.</span>
            </div>
            <div class="shipping-type-check">
                <mat-icon *ngIf="!shippeable">
                    check_circle
                </mat-icon>
            </div>
        </button>
        <button type="button" class="shipping-type-option" [class.selected]="shippeable"
            (click)="changeSelectedShipping('Send')">
            <div class="shipping-type-icon">
                <mat-icon>local_shipping</mat-icon>
            </div>
            <div class="shipping-type-text">
                <strong>Con envío</strong>
                <span>Recibe tu pedido en la dirección que elijas.</span>
            </div>
            <div class="shipping-type-check">
                <mat-icon *ngIf="shippeable">
                    check_circle
                </mat-icon>
            </div>
        </button>
    </section>
    <!-- =====================================================
         RECOGER EN SUCURSAL
         ===================================================== -->
    <section class="pickup-section" *ngIf="shippeable == false">
        <div class="section-heading">
            <span class="section-eyebrow">
                RECOGER EN SUCURSAL
            </span>
            <h3>
                Elige una sucursal
            </h3>
            <p>
                Selecciona la sucursal donde deseas recoger tu pedido.
            </p>
        </div>
        <div class="pickup-layout" *ngIf="sucursalesWithTheProduct.length > 0">
            <!-- INFORMACIÓN DE SUCURSAL -->
            <div class="branch-detail-card" *ngIf="sucursal != null">
                <div class="branch-detail-header">
                    <span class="branch-detail-label">
                        SUCURSAL SELECCIONADA
                    </span>
                    <h4>
                        {{ sucursal.nombre }}
                    </h4>
                </div>
                <div class="branch-info-list">
                    <div class="branch-info-item">
                        <mat-icon>
                            location_on
                        </mat-icon>
                        <span>
                            {{ sucursal.direccion }}
                        </span>
                    </div>
                    <div class="branch-info-item">
                        <mat-icon>
                            schedule
                        </mat-icon>
                        <span>
                            {{ sucursal?.horario }}
                        </span>
                    </div>
                    <div class="branch-info-item">
                        <mat-icon>
                            call
                        </mat-icon>
                        <span>
                            Teléfono: {{ sucursal.telefono }}
                        </span>
                    </div>
                    <div class="branch-info-item" *ngIf="sucursal.celularSucursal">
                        <mat-icon>
                            smartphone
                        </mat-icon>
                        <span>
                            Celular: {{ sucursal.celularSucursal }}
                        </span>
                    </div>
                </div>
                <div class="branch-image" *ngIf="sucursal.urlFoto">
                    <img [src]="sucursal.urlFoto" [alt]="sucursal.nombre">
                </div>
            </div>
            <!-- SUCURSALES -->
            <div class="branches-selector">
                <div class="branches-selector-header">
                    <span>
                        SUCURSALES DISPONIBLES
                    </span>
                </div>
                <mat-chip-listbox *ngIf="sucursalesWithTheProduct.length > 0" class="branches-chip-list"
                    aria-label="Sucursales">
                    <mat-chip-option *ngFor="let branch of sucursalesWithTheProduct" [selected]="branch.selected"
                        (selectionChange)="changeSelectedChip($event, branch)" class="branch-chip">
                        {{ branch.sucursal.length > 9 ? 'Suc.' : 'Sucursal' }}
                        {{ branch.sucursal }}
                    </mat-chip-option>
                </mat-chip-listbox>
                <button class="shipping-primary-button" mat-raised-button type="button" (click)="continue()"
                    [disabled]="sucursal.idSucursal <= 0">
                    CONTINUAR
                </button>
            </div>
        </div>
    </section>
    <!-- =====================================================
         CON ENVÍO
         ===================================================== -->
    <section class="delivery-section" *ngIf="shippeable == true">
        <div class="section-heading">
            <span class="section-eyebrow">
                ENTREGA A DOMICILIO
            </span>
            <h3>
                ¿Dónde quieres recibir tu pedido?
            </h3>
            <p>
                Busca una dirección o selecciona directamente un punto en el mapa.
            </p>
        </div>
        <div class="delivery-content" *ngIf="sucursalesWithTheProduct.length > 0">
            <!-- DIRECCIÓN DE ENTREGA -->
            <div class="address-search-row">
                <!-- BUSCADOR DE GOOGLE MAPS: solo si todavía no hay dirección guardada -->
                <mat-form-field class="address-search" appearance="outline" *ngIf="!savedAddress">
                    <mat-label>Dirección de entrega</mat-label>
                    <input matInput #searchInput autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                        placeholder="Busca tu dirección" [(ngModel)]="direccion">
                    <mat-icon matSuffix>location_on</mat-icon>
                </mat-form-field>
                <!-- DIRECCIÓN GUARDADA: solo lectura -->
                <mat-form-field class="address-search saved-address-field" appearance="outline" *ngIf="savedAddress">
                    <mat-label>Dirección de entrega seleccionada</mat-label>
                    <input matInput type="text" [value]="savedAddressDisplay" readonly>
                    <mat-icon matSuffix>lock</mat-icon>
                </mat-form-field>
                <button *ngIf="tokenSSLoged && !savedAddress" class="address-button" mat-stroked-button type="button"
                    (click)="openDialogAddresses(objMyDirection)">
                    <mat-icon>home</mat-icon>
                    Mis direcciones
                </button>
                <!-- Permite cambiarla abriendo de nuevo el selector de direcciones -->
                <button *ngIf="tokenSSLoged && savedAddress" class="address-button" mat-stroked-button type="button"
                    (click)="openDialogAddresses(objMyDirection)">
                    <mat-icon>edit_location_alt</mat-icon>
                    Cambiar dirección
                </button>
            </div>
            <!-- SIN SUCURSALES -->
            <p class="no-branches-message" *ngIf="sucursalesCercanas.length === 0 || sucursalesCercanas === null || sucursalesCercanas === undefined">
                No hay sucursales cerca de tu ubicación con el producto que deseas.
            </p>
            <!-- MAPA -->
            <div class="map-section">
                <div class="map-header">
                    <div>
                        <span>
                            UBICACIÓN
                        </span>
                        <h4>
                            Selecciona tu ubicación
                        </h4>
                    </div>
                    <div class="map-location-hint" [class.location-locked]="savedAddress">
                        <mat-icon>{{ savedAddress ? 'lock' : 'near_me' }}</mat-icon>
                        {{ savedAddress ? 'Ubicación guardada' : 'Puedes mover el pin' }}
                    </div>
                </div>
                <div class="map-container">
                    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom"
                        [gestureHandling]="savedAddress ? 'none' : 'auto'"
                        (mapClick)="!savedAddress && onMapClickEvent($event)">
                        <!-- UBICACIÓN DEL USUARIO -->
                        <agm-marker [latitude]="myLatitude" [longitude]="myLongitude"
                            (dragEnd)="!savedAddress && markerDragEnd($event)" [markerDraggable]="!savedAddress"
                            *ngIf="myLatitude && myLongitude">
                            <agm-info-window [isOpen]="true" #infoWindow>
                                <div class="map-info-window">
                                    <strong>
                                        Tu ubicación
                                    </strong>
                                    <!-- <span>
                                        {{ direccion || 'Ubicación seleccionada' }}
                                    </span> -->
                                </div>
                            </agm-info-window>
                        </agm-marker>
                        <!-- SUCURSALES -->
                        <agm-marker *ngFor="let sucursal of sucursalesCercanas" [latitude]="sucursal.latitud"
                            [longitude]="sucursal.longitud" [markerClickable]="true">
                            <agm-info-window [isOpen]="false" #infoWindow>
                                <div class="map-branch-window">
                                    <strong>
                                        {{ sucursal.nombre }}
                                    </strong>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </agm-map>
                </div>
            </div>
            <!-- CONTINUAR -->
            <div class="delivery-footer">
                <button class="shipping-primary-button" mat-raised-button type="button" (click)="continue()"
                    [disabled]="sucursal.idSucursal <= 0">
                    CONTINUAR
                </button>
            </div>
        </div>
    </section>
</mat-dialog-content>